import {v4 as uuid} from "uuid";
import {LabelTextControl} from "../../controls";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {RemoveButtonControl} from "../../controls/RemoveButtonControl";

export class TextQuestion {

    constructor(parentComponent, textQuestionAdded, textQuestionRemoved) {
        this.parentComponent = parentComponent;
        this.onTextQuestionAdded = textQuestionAdded;
        this.onTextQuestionRemoved = textQuestionRemoved;
        this.isAdded = false;
    }

    addTextQuestion(node, textQuestionUUID = null) {
        if (textQuestionUUID == null) {
            textQuestionUUID = uuid();
        }

        const questionControl = new LabelTextControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getTextQuestionQuestionKey(textQuestionUUID),
            node,
            false,
            "Question"
        );

        const removeTextQuestionControl = new RemoveButtonControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getTextQuestionRemoveButtonKey(textQuestionUUID),
            node,
            false,
            () => this.onRemoveTextQuestionClick.bind(this, node, textQuestionUUID, removeTextQuestionControl, questionControl)
        );

        node
            .addControl(removeTextQuestionControl)
            .addControl(questionControl);

        this.textQuestionAdded(node, textQuestionUUID);
        node.update();
    }

    textQuestionAdded(node, addedTextQuestionUUID) {
        this.isAdded = true;
        this.onTextQuestionAdded();
    }

    onRemoveTextQuestionClick(node, textQuestionUUID, removeTextQuestionControl, questionControl) {
        this.removeTextQuestion(node, textQuestionUUID, removeTextQuestionControl, questionControl)
            .then(r => {
                this.textQuestionRemoved(node, textQuestionUUID);
            });
    }

    async removeTextQuestion(node, textQuestionUUID, removeTextQuestionControl, questionControl) {
        node.removeControl(removeTextQuestionControl);
        node.removeControl(questionControl);

        node.update();

        delete node.data[SequenceComponentHelper.getTextQuestionQuestionKey(textQuestionUUID)];
    }

    async textQuestionRemoved(node, removedTextQuestionUUID) {
        this.isAdded = false;
        this.onTextQuestionRemoved();
    }
}